import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import api from '../services/api';
import './Cadastro.css';

export default function ResetSenha() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [senha, setSenha] = useState('');
  const [senha2, setSenha2] = useState('');
  const [verSenha, setVerSenha] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (!token) setErro('Link inválido. Solicite uma nova recuperação de senha.');
  }, [token]);

  const senhaForte = senha.length >= 8 && /[A-Za-z]/.test(senha) && /\d/.test(senha);
  const senhasIguais = senha && senha === senha2;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    if (!senhaForte) return setErro('A senha deve ter pelo menos 8 caracteres, com letras e números.');
    if (!senhasIguais) return setErro('As senhas não conferem.');

    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, senha });
      setSucesso(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setErro(
        err.response?.data?.error ||
          'Não foi possível redefinir a senha. O link pode ter expirado.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cadastro-page">
      <form className="cadastro-card" onSubmit={handleSubmit} style={{ maxWidth: 420 }} noValidate>
        <div className="cadastro-logo">
          <h1>LicitaPRO</h1>
        </div>
        <p className="cadastro-subtitle">Redefinir senha</p>

        {sucesso ? (
          <div style={{ textAlign: 'center', padding: '16px 8px' }}>
            <FiCheckCircle size={42} color="#00874a" />
            <h3 style={{ margin: '12px 0 8px', color: '#1a202c' }}>Senha redefinida!</h3>
            <p style={{ color: '#555', fontSize: '0.92rem', margin: 0 }}>
              Você será redirecionado para o login em instantes.
            </p>
          </div>
        ) : (
          <>
            {erro && (
              <div className="cadastro-error">
                <FiAlertCircle size={14} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                {erro}
              </div>
            )}

            <p style={{ color: '#555', fontSize: '0.88rem', margin: '0 0 18px', textAlign: 'center' }}>
              Crie uma nova senha de acesso. Ela deve ter pelo menos 8 caracteres com letras e números.
            </p>

            <div className="cadastro-field">
              <label htmlFor="senha">Nova senha</label>
              <div className="cadastro-input-wrap">
                <input
                  id="senha"
                  type={verSenha ? 'text' : 'password'}
                  placeholder="Mínimo 8 caracteres"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  required
                  autoFocus
                  disabled={!token}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="cadastro-toggle-senha"
                  onClick={() => setVerSenha(!verSenha)}
                  aria-label={verSenha ? 'Ocultar senha' : 'Mostrar senha'}
                >
                  {verSenha ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
              {senha && (
                <span
                  className={`cadastro-hint ${senhaForte ? 'cadastro-hint-ok' : 'cadastro-hint-erro'}`}
                >
                  {senhaForte ? 'Senha forte' : 'Use 8+ caracteres com letras e números'}
                </span>
              )}
            </div>

            <div className="cadastro-field">
              <label htmlFor="senha2">Confirmar nova senha</label>
              <input
                id="senha2"
                type={verSenha ? 'text' : 'password'}
                placeholder="Repita a senha"
                value={senha2}
                onChange={(e) => setSenha2(e.target.value)}
                required
                disabled={!token}
                autoComplete="new-password"
              />
              {senha2 && !senhasIguais && (
                <span className="cadastro-hint cadastro-hint-erro">As senhas não conferem</span>
              )}
            </div>

            <button
              className="cadastro-btn"
              type="submit"
              disabled={loading || !token || !senhaForte || !senhasIguais}
            >
              {loading ? 'Salvando...' : 'Redefinir senha'}
            </button>
          </>
        )}

        <p className="cadastro-rodape">
          <Link to="/login">← Voltar para o login</Link>
        </p>
      </form>
    </div>
  );
}
